module.exports = __webpack_public_path__ + "static/map-61a84fca01f65343d82c363e689f3092.png";